var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDsg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "89px",
    height: "72px",
    viewBox: "0 0 89 72",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "97432E2C-1D8B-4C95-AEE8-A014E11DD667") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "25.-Part-2---Who-can-use-Hana-UI\\\\\\\\",
    transform: "translate(-346.000000, -715.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(348.000000, 717.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.61731,25.844958 C13.31541,10.999638 26.73639,1.8e-05 42.72651,1.8e-05 C58.71663,1.8e-05 72.13761,10.999638 75.83571,25.844958",
    id: "Stroke-1",
    stroke: "#222456",
    strokeWidth: 2.52,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.835692,42.39423 C72.137592,57.23973 58.716612,68.23899 42.726672,68.23899 C26.736552,68.23899 13.315392,57.23955 9.617292,42.39423",
    id: "Stroke-3",
    stroke: "#222456",
    strokeWidth: 2.52,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-5",
    stroke: "#EE7330",
    strokeWidth: 2.52,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "66.0924 25.875198 75.82194 34.764858 85.57902 25.844958 75.95748 25.859898"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-7",
    stroke: "#EE7330",
    strokeWidth: 2.52,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "19.486638 42.364008 9.757098 33.474168 1.8e-05 42.394248 9.621738 42.379308"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.892306,30.329316 L26.892306,37.741716 L28.982466,37.741716 C31.195566,37.741716 32.688486,36.248616 32.688486,34.070616 L32.688486,34.035516 C32.688486,31.857516 31.195566,30.329316 28.982466,30.329316 L26.892306,30.329316 Z M24.187446,27.887976 L28.982466,27.887976 C32.846706,27.887976 35.516466,30.540276 35.516466,34.000416 L35.516466,34.035516 C35.516466,37.495656 32.846706,40.182876 28.982466,40.182876 L24.187446,40.182876 L24.187446,27.887976 Z",
    id: "Fill-9",
    fill: "#222456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.60758,38.391354 L39.20598,36.476694 C40.31244,37.390194 41.47182,37.969794 42.8769,37.969794 C43.98354,37.969794 44.65098,37.530774 44.65098,36.810774 L44.65098,36.775494 C44.65098,36.090414 44.22942,35.739234 42.17436,35.212194 C39.69774,34.580034 38.09934,33.894954 38.09934,31.453614 L38.09934,31.418514 C38.09934,29.187774 39.89106,27.712314 42.40278,27.712314 C44.19432,27.712314 45.72234,28.274454 46.96938,29.275614 L45.5643,31.313034 C44.4753,30.557754 43.40394,30.101094 42.3675,30.101094 C41.33124,30.101094 40.78674,30.575394 40.78674,31.172454 L40.78674,31.207554 C40.78674,32.015394 41.3136,32.279094 43.43886,32.823594 C45.93312,33.473394 47.33838,34.369074 47.33838,36.511974 L47.33838,36.547074 C47.33838,38.988594 45.47646,40.358754 42.82416,40.358754 C40.96242,40.358754 39.08304,39.708594 37.60758,38.391354",
    id: "Fill-11",
    fill: "#222456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.85082,34.070652 L49.85082,34.035552 C49.85082,30.540312 52.57332,27.677052 56.29698,27.677052 C58.51008,27.677052 59.84496,28.274472 61.1271,29.363292 L59.4234,31.418532 C58.47498,30.628152 57.63186,30.171492 56.20914,30.171492 C54.24192,30.171492 52.67862,31.910292 52.67862,34.000272 L52.67862,34.035552 C52.67862,36.283752 54.22428,37.934712 56.40228,37.934712 C57.38598,37.934712 58.2642,37.689012 58.9491,37.197072 L58.9491,35.440632 L56.2266,35.440632 L56.2266,33.104592 L61.56612,33.104592 L61.56612,38.444112 C60.30162,39.515652 58.56264,40.393872 56.31444,40.393872 C52.48548,40.393872 49.85082,37.706472 49.85082,34.070652",
    id: "Fill-13",
    fill: "#222456"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDsg);
export default __webpack_public_path__ + "static/media/dsg.5a0dde21.svg";
export { ForwardRef as ReactComponent };